import React from 'react';
import { IconProps } from './types/Icon.type';

function Close20Icon(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8272 5.1065C14.5343 4.81361 14.0594 4.81361 13.7665 5.1065L5.28126 13.5918C4.98837 13.8847 4.98837 14.3596 5.28126 14.6524C5.57416 14.9453 6.04903 14.9453 6.34192 14.6524L14.8272 6.16716C15.1201 5.87427 15.1201 5.3994 14.8272 5.1065Z"
        fill="#121212"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.39936 5.2276C5.69225 4.9347 6.16712 4.9347 6.46002 5.2276L14.9453 13.7129C15.2382 14.0058 15.2382 14.4806 14.9453 14.7735C14.6524 15.0664 14.1775 15.0664 13.8846 14.7735L5.39936 6.28826C5.10646 5.99536 5.10646 5.52049 5.39936 5.2276Z"
        fill="#121212"
      />
    </svg>
  );
}

export default Close20Icon;
